<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card :loading="tt_load" flat class="box v-card">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    Time Table 
                </v-toolbar-title>
                <v-divider class="mx-4" color="white" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-btn class="no-display" rounded color="success" small 
                            @click="fnExcelReport('my-table-id', 'FacultyTT')"><v-icon small class="mr-1"
                                color="white">mdi-export</v-icon>Export</v-btn>
                                <v-btn class="ma-2 no-display" color="warning" small rounded
                            @click="CartPdf()"><v-icon small class="mr-1">mdi-printer</v-icon>Print</v-btn>
                <v-checkbox v-model="showRoom" color="white" text-color="white" class="checkbox-label"></v-checkbox>Show
                Room
            </v-toolbar>
            <v-card flat v-if="final_tt_list != null">              
                <div id="my-table-id">
                    <br>
                    <v-row justify="center">
                        <caption>
                            <b>{{ faculty.employee_code }} : {{ faculty_name }}</b>
                        </caption>
                    </v-row>
                    <v-col cols="12" sm="12" md="12" class="pa-1" v-for="(ftt, index) in final_tt_list" :key="index">
                        <center> <b> Stream :: </b> {{ ftt.stream }} </center>
                        <br>
                        <v-simple-table class="elevation-1 mytable" dense>
                            <thead>
                                <tr>
                                    <th style="background-color: #ffd699;">AY:{{ dis_ay.ay }}</th>
                                    <!-- <th  style="background-color: #b3d4fc;" v-for="s in slots" :key="s.id">{{s.start_time}}</th> -->
                                    <th class="toolbar" v-for="(s, index) in ftt.slot" :key="index">
                                        {{ s.start_time }} - {{ s.end_time }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(tt, index) in ftt.tt_list" :key="index">
                                    <th width="10%" class="toolbar">
                                        <center>{{ tt[0].tt_day }}</center>
                                    </th>
                                    <td v-for="(data, index) in tt" :key="index">
                                        <!-- {{data}} -->
                                        <v-btn v-if="data.toshowcompulsory == 0" class="btn-grad"
                                            @click="addweblink(data.tt_web_link, data.tt_id)" width="100%" small
                                            :color="data.tt_slot_color"
                                            :title="`Subject:${data.tt_course_tip} Std:${data.tt_std} Div:${data.tt_div} Room:${data.tt_room} Event:${data.tt_event_tip}`">
                                            <span v-if="data.tt_course != null">
                                                <v-icon small color="green">mdi-book-open-page-variant</v-icon>
                                                {{ data.tt_course }}
                                            </span>
                                            <a :href="data.tt_web_link"
                                                v-if="data.tt_web_link != null && data.tt_web_link != '--'"
                                                target="_blank">
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon color="white" v-bind="attrs" v-on="on" size="25">mdi
                                                            mdi-link</v-icon>
                                                    </template>
                                                    <span> Webinar Link!!! </span>
                                                </v-tooltip>
                                            </a>
                                            <span v-if="showRoom && data.tt_room != null">
                                                <v-icon color="blue" small>mdi-warehouse</v-icon>
                                                {{ data.tt_room }}
                                            </span>
                                            <span v-if="data.tt_event != null">
                                                <v-icon color="green" small>mdi-cricket</v-icon>
                                                {{ data.tt_event }}
                                            </span>
                                            <span v-if="data.tt_div != null">
                                                <v-icon color="#9808EB" small>mdi-standard-definition</v-icon>
                                                {{ data.tt_std }}-{{ data.tt_div }}
                                            </span>
                                            <span v-if="data.tt_mul_inst != ''">
                                                <v-icon color="#9808EB" small>mdi-account-plus</v-icon>
                                                <span v-for="i, index in data.tt_mul_inst" :key="index"> {{ index + 1 }}.{{ i
                                                    }}</span>
                                            </span>
                                        </v-btn>
                                        <template v-if="data.toshowcompulsory == 1">
                                            <span v-if="data.electives.length != 0">
                                                <v-tooltip right color="#00DBDE" dark>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn v-bind="attrs" v-on="on" width="100%"
                                                            @click="addweblink(data.tt_web_link, data.tt_id)"
                                                            :id="data.tt_id" v-for="(ele, index) in data.electives"
                                                            :key="index" small class="pt-2 mt-2 btn1-grad"
                                                            :title="`Subject:${ele.ele_crs} Std:${ele.ele_std} Div:${ele.ele_div} Room:${ele.ele_room} Event:${ele.ele_event} Instructor:${ele.ele_instructor}`">
                                                            <span v-if="ele.ele_crs != null">
                                                                <v-icon small
                                                                    color="green">mdi-book-open-page-variant</v-icon>
                                                                {{ ele.ele_crs }}
                                                            </span>
                                                            <a :href="ele.ele_link" v-if="ele.ele_link" target="_blank">
                                                                <v-tooltip top>
                                                                    <template v-slot:activator="{ on, attrs }">
                                                                        <v-icon color="white" v-bind="attrs" v-on="on"
                                                                            size="20">mdi mdi-link</v-icon>
                                                                    </template>
                                                                    <span> Webinar Link!!! </span>
                                                                </v-tooltip>
                                                            </a>
                                                            <span v-if="showRoom && ele.ele_room != null">
                                                                <v-icon color="blue" small>mdi-warehouse</v-icon>
                                                                {{ ele.ele_room }}
                                                            </span>
                                                            <span v-if="ele.ele_event != null">
                                                                <v-icon color="green" small>mdi-cricket</v-icon>
                                                                {{ ele.ele_event }}
                                                            </span>
                                                            <span v-if="ele.ele_instructor != '--'">
                                                                <v-icon color="#9808EB" small>mdi-account-tie</v-icon>
                                                                {{ ele.ele_instructor }}
                                                            </span>
                                                            <span v-if="ele.tt_ele_mul_inst != ''">
                                                                <v-icon color="#9808EB" small>mdi-account-plus</v-icon>
                                                                <span v-for="i, index in ele.tt_ele_mul_inst"
                                                                    :key="index"> {{ index + 1 }}.{{ i }}</span>
                                                            </span>
                                                        </v-btn>
                                                    </template>
                                                    <span> Elective Time Table </span>
                                                </v-tooltip>
                                            </span>
                                        </template>
                                        <template v-if="data.toshowcompulsory == 2">

                                            <!-- {{ data }} -->

                                            <v-btn v-if="data.toshowcompulsory == 2" width="100%" small
                                                class="btn2-mul">
                                                <span v-if="data.tt_course != null">
                                                    <v-icon small color="green">mdi-book-open-page-variant</v-icon>
                                                    {{ data.tt_course }}
                                                </span>
                                                <span v-if="showRoom && data.tt_room != null">
                                                    <v-icon color="blue" small>mdi-warehouse</v-icon>
                                                    {{ data.tt_room }}
                                                </span>
                                                <span v-if="data.tt_event != null">
                                                    <v-icon color="green" small>mdi-cricket</v-icon>
                                                    {{ data.tt_event }}
                                                </span>
                                                <span v-if="data.tt_div != null">
                                                    <v-icon color="#9808EB" small>mdi-standard-definition</v-icon>
                                                    {{ data.tt_std }}-{{ data.tt_div }}
                                                </span>
                                                <span v-if="data.tt_faculty != null">
                                                    <v-icon color="#9808EB" small>mdi-account-tie</v-icon>
                                                    {{ data.tt_faculty }}
                                                </span>
                                                <span v-if="data.tt_web_link != null && data.tt_web_link != '--'">
                                                    <a :href="data.tt_web_link" v-if="data.tt_web_link" target="_blank">
                                                        <v-tooltip top>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-icon color="white" v-bind="attrs" v-on="on"
                                                                    size="25">mdi mdi-link</v-icon>
                                                            </template>
                                                            <span> Webinar Link!!! </span>
                                                        </v-tooltip>
                                                    </a>
                                                </span>
                                            </v-btn>
                                        </template>
                                        <template v-if="data.toshowcompulsory == 3">
                                            <span v-if="data.tt_slot_type == 'Teaching'">
                                                --
                                            </span>
                                            <span v-else>
                                                <v-btn small :color="data.tt_slot_color"> {{ data.tt_slot_type }}
                                                </v-btn>
                                            </span>
                                        </template>
                                        <!-- </template>
                                <span>
                                    <template v-if="data.tt_slot_stream!=null">
                                    <v-icon color="#fff" small>mdi mdi-code-string</v-icon>
                                    {{data.tt_slot_stream}}
                                     </template>
                                </span>
                                </v-tooltip> -->
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                        <br>
                    </v-col>
                </div>

            </v-card>
            <v-dialog v-model="dialog" persistent max-width="900px">
                <v-card>
                    <v-toolbar class="toolbar" flat dense>
                        <v-toolbar-title>
                            <strong> Add / Edit Webinar Link </strong>
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-col cols="12" sm="12" md="12">
                        <v-card class="box">
                            <center>
                                <v-col cols="6" sm="6" md="6">
                                    <!-- {{web_Link}} -->
                                    <v-text-field color="#0F2027" rounded v-model="web_Link" dense clearable
                                        return-object outlined hint=" Enter Webinar Link"
                                        @change="validateWebinarURL(web_Link)" persistent-hint></v-text-field>
                                </v-col>
                            </center>
                        </v-card>
                        <v-row justify="center">
                            <v-btn rounded class="button" @click="save">Save</v-btn>
                            <v-btn rounded class="button" @click="dialog = false">Close</v-btn>

                            <a :href="web_Link" v-if="web_Link != null" target="_blank">
                                <v-btn rounded class="button" v-if="web_Link != null">
                                    Open Weninar Link
                                </v-btn>
                            </a>
                        </v-row>
                    </v-col>
                </v-card>
            </v-dialog>
        </v-card>
    </div>
</template>
<script>
import axios from "axios";
//  import jsPDF from "jspdf";
// import domtoimage from "dom-to-image";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    props: {
        uid: String,
        ay: String,
        stream: Array,
        org: Number,
        tt_version: Number,
        context: {
            type: String,
            default: "default"
        } 
    },
    data() {
        return {
            final_tt_list: null,
            tt_list: null,
            slots: null,
            slot_type: null,
            faculty: null,
            tt_load: false,
            dis_ay: null,
            faculty_name: "",
            dialog: false,
            web_Link: null,
            tt_id: null,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            showRoom: true,
        };
    },
    watch: {
        uid() {
            this.getData();
        },
        tt_version() {
            this.getData();
        }
    },
    mounted() {
        //  this.uid = JSON.parse(localStorage.getItem("uid"));
        //  this.ay = JSON.parse(localStorage.getItem("curr_ay"));
        //  this.stream = JSON.parse(localStorage.getItem("stream"));
        this.getData();
    },
    methods: {
        fnExcelReport(id, name) {
            var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
            tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
            tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
            tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
            tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
            tab_text = tab_text + "<table border='1px'>";
            var exportTable = $("#" + id).clone();
            exportTable.find("input").each(function (index, elem) {
                $(elem).remove();
            });
            exportTable.find('th, td').each(function () {
                $(this).css('border', '1px solid black');
            });
            tab_text = tab_text + exportTable.html();
            tab_text = tab_text + "</table></body></html>";
            var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

            //Save the file
            // var blob = new Blob([tab_text], {
            //     type: "application/vnd.ms-excel;charset=utf-8",
            // });
            // window.saveAs(blob, fileName);
            const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const filename = name + '.xls';

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                // For IE
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                // For modern browsers
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
            }
        },
        validateWebinarURL(link) {
            //  alert("validateWebinarURL::"+link)
            var myURL = link;
            var mytrimurl = myURL.trim();
            var pattern = new RegExp(
                "^((ft|htt)ps?:\\/\\/)?" + // protocol
                "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name and extension
                "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
                "(\\:\\d+)?" + // port
                "(\\/[-a-z\\d%@_.~+&:]*)*" + // path
                "(\\?[;&a-z\\d%@_.,~+&:=-]*)?" + // query string
                "(\\#[-a-z\\d_]*)?$",
                "i"
            ); // fragment locator');
            if (pattern.test(mytrimurl)) {
                this.isvalid = true;
                return;
            } else {
                alert("Please Enter Valid URL...!");
                this.isvalid = false;
                return;
            }
        },
        addweblink(weblink, tt_id) {
            this.web_Link = weblink;
            this.tt_id = tt_id;
            this.dialog = true;
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        save() {
            if (!this.org) {
                if (!this.isvalid) {
                    alert("Please Enter valid Link...");
                    return;
                }

                const formData = {
                    tt_id: this.tt_id,
                    web_Link: this.web_Link,
                };
                axios
                    .post("/timeTable/saveWeblink", formData)
                    .then((res) => {
                        if (res.data.status == "YES") {
                            if (res.data.status == "YES") {
                                this.showSnackbar("#4caf50", "Webinar Link Save Successfully..."); // show snackbar on success
                                this.dialog = false;
                            }
                        } else {
                            alert(res.data.status_reason);
                            this.dialog = false;
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.dialog = false;
                    });
            }
        },
        print() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },
        // genPdf() {
        //     domtoimage
        //         .toPng(this.$refs.content)
        //         .then(function (dataUrl) {
        //             var img = new Image();
        //             img.src = dataUrl;
        //             const doc = new jsPDF({
        //                 orientation: "portrait",
        //                 // unit: "pt",
        //                 //format: [200, 200]
        //             });
        //             doc.addImage(img, "JPEG", 1, 1);
        //             const date = new Date();
        //             const filename = "cert.pdf";
        //             doc.save(filename);
        //         })
        //         .catch(function (error) {
        //             // console.error("oops, something went wrong!", error);
        //         });
        // },
        CartPdf() {
            var tab = document.getElementById('my-table-id');
            var win = window.open('', '', 'height=1000,width=3000');
            win.document.write(tab.outerHTML);
            win.document.close();
            win.print();
        },
        getData() {
            this.tt_load = true;
            const formData = {
                uid: this.uid,
                ay: this.ay,
                stream: this.stream,
                org: this.org,
                tt_version: this.tt_version
            };
            const apiUrl =
            this.context === "individual"
                ? "/timeTable/facultyIndividualTimeTable"
                : "/timeTable/facultyTimeTable";
            axios
                .post(apiUrl, formData)
                .then((res) => {
                    console.log(res.data);
                    if (res.data.status == "YES") {
                        this.tt_list = res.data.tt_list;
                        console.log(this.tt_list);
                        this.slots = res.data.slot;
                        this.slot_type = res.data.slot_type;
                        this.faculty = res.data.faculty;
                        this.dis_ay = res.data.ay;
                        this.final_tt_list = res.data.final_tt_list;
                        this.faculty_name = res.data.faculty_name;
                    } else {
                        alert(res.data.status_reason);
                    }
                })
                .catch((error) => {
                    alert("Somthing went wrong!!!");
                })
                .finally(() => {
                    //stop loader
                    this.tt_load = false;
                });
        },
    },
};
</script>
<style scoped>
@media print {

    /* @transform: scale(50); */
    .no-display {
        display: none !important;
    }

    /* .schlImg {
            width: 84%;
        } */
    @page {
        /* size: A3 landscape !important; */
        /* size: 279.4mm  215.9mm !important; */
        /* size:17in 11in; */
        /* scale: 50; */
        /* size: landscape; */
        /* -webkit-transform: rotate(-90deg); 
            -moz-transform:rotate(-90deg);
            filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=3); */
        margin-top: none !important;
        padding-top: none !important;
        size: A4 landscape !important;
        scale: 50;
        /* page-break-inside: avoid; */
    }

    /* body { 
        writing-mode: tb-rl;
    } */

}

a:link {
    text-decoration: none !important;
}

td,
th {
    border: 1px solid #ccc;
}

tr,
tbody {
    border-bottom: 1px solid #ccc;
    border: 1px solid #ccc;
}

td {
    margin: 0.3rem !important;
    padding: 0.4rem !important;
}

@media (min-width: 320px) {

    td,
    th {
        display: table-cell !important;
    }

    td+td,
    th+th {
        width: auto;
    }
}

v-simple-table {
    white-space: nowrap !important;
    text-align: center;
}

thead {
    font-weight: bold !important;
}

th {
    font-weight: bold !important;
}

tr,
td,
th {
    border: 1px solid black;
    /* text-align: center; */
    font-size: small;
}

tr,
tbody {
    border-bottom: 1px solid black;
    border: 1px solid black;
    font-size: small;
}

td {
    font-size: small;
}

.checkbox-label {
    /* color: #fff !important; */
    margin-left: 10px;
    margin-top: 24px;
}

.btn-grad {
    /* background-image: linear-gradient(to right, #abbaab 0%, #ffffff  51%, #abbaab  100%) */
}

.btn-grad {
    text-align: center;
    text-transform: uppercase;
    transition: 0.5s;
    background-size: 200% auto;
    color: black;
    border-radius: 10px;
    display: block;
}

.btn-grad:hover {
    background-position: right center;
    /* change the direction of the change here */
    color: black;
    text-decoration: none;
}

.btn1-grad {
    background-image: linear-gradient(to right, #085078 0%, #85d8ce 51%, #085078 100%);
}

.btn1-grad {
    text-align: center;
    text-transform: uppercase;
    transition: 0.5s;
    background-size: 200% auto;
    color: white;
    box-shadow: 0 0 20px #eee;
    border-radius: 10px;
    display: block;
}

.btn1-grad:hover {
    background-position: right center;
    /* change the direction of the change here */
    color: #fff;
    text-decoration: none;
}

.btn2-mul {
    background-image: linear-gradient(to right, #c3b464, #d0a96d, #d4a07a, #cf9a88, #c49794);
    box-shadow: 0 0 20px #eee;
    border-radius: 10px;
    display: block;
    color: white;
    text-align: center;
    text-transform: uppercase;
    transition: 0.5s;
}
</style>
